import React from 'react';
import MailerSendLogo from "../../../images/background/mailerSendDtl.png"

const MailerSendStatic = (props) => {
    return (
        <div>
            <div style={{ marginTop: 8 }}>
                <img src={MailerSendLogo} alt='' style={{ width: '100%', borderRadius: 4, border: '1px solid #DFDFDF' }} />
            </div>
            <div style={{ marginTop: 8, fontSize: 14, fontWeight: 400, marginBottom: 16 }}>
                Ажилтныхаа цалинг байгууллага хэзээ, хэрхэн бодсон тухай дэлгэрэнгүй мэдээллийг ажилтан бүрт өгөх нь чухал нөлөөтэй байдаг. Энэхүү нэмэлт нь цалингаа бодоод, хянаж дуусгасны дараа үндсэн цалин, ажилласан цаг, бодогдсон цалин, нэмэгдэл, суутгал, жинхэнэ олгох дүн гэх мэт мэдээллийг ажилтан тус бүрийн бүртгэлтэй имэйл хаяг руу илгээх нэмэлт юм.
            </div>
        </div>
    );
}

export default MailerSendStatic;